// Checkout add-ons: the priced selection lives ON the pending booking row
// (bookings.addons + addons_cents inside amount_cents), so every checkout
// flavour — intents, free path, codes, gift cards, webhook, refunds — prices
// them automatically. This wrapper replaces a booking's selection wholesale.

import { supabase } from "../config";

export interface AddonSelection {
  addon_id: string;
  qty: number;
}

export interface AddonSnapshotLine {
  addon_id: string;
  name: string;
  qty: number;
  unit_price_cents: number;
  currency: string;
}

export async function setBookingAddons(input: {
  bookingId: string;
  cartToken: string;
  addons: AddonSelection[];
}): Promise<
  | { ok: true; addons: AddonSnapshotLine[]; addons_cents: number; amount_cents: number }
  | { ok: false; reason: string }
> {
  const { data, error } = await supabase.rpc("set_booking_addons", {
    p_booking_id: input.bookingId,
    p_cart_token: input.cartToken,
    p_addons: input.addons,
  });
  if (error || !data) return { ok: false, reason: error?.message ?? "network_error" };
  return data as
    | { ok: true; addons: AddonSnapshotLine[]; addons_cents: number; amount_cents: number }
    | { ok: false; reason: string };
}
